// Centralized site data — also used as defaults if no localStorage overrides exist.
// Admin can edit these via /admin (changes persist in localStorage).

export const BUSINESS = {
  name: "AURA Estética Corporal & Spa",
  director: "Zaida Meléndez",
  tagline: "Belleza, salud y bienestar en manos de expertas.",
  whatsapp: "+51 937 373 507",
  whatsappNumberOnly: "51937373507",
  email: "contacto@auraestetica.spa",
  address: "SJM - Lima · Atención con cita previa",
  hours: [
    { day: "Lunes a Viernes", time: "9:00 AM - 7:00 PM" },
    { day: "Sábado", time: "9:00 AM - 5:00 PM" },
    { day: "Domingo", time: "Cerrado" },
  ],
  social: {
    instagram: "https://instagram.com/aura.estetica.spa",
    facebook: "https://facebook.com/aura.estetica.spa",
    tiktok: "https://tiktok.com/@aura.estetica.spa",
  },
  mapsEmbed: "https://www.google.com/maps?q=Aura+Spa+y+estetica&ll=-12.1875646,-76.9762732&z=17&hl=es&output=embed",
  logo: "https://customer-assets.emergentagent.com/job_6f6f25ef-83eb-4901-94ce-65635eac606a/artifacts/htemq9qg_Z%20%288%29.png",
  // Yape payment settings (editable from admin)
  yape: {
    enabled: true,
    holder: "Zaida Meléndez",
    phone: "937 373 507",
    qr: "https://customer-assets.emergentagent.com/job_6f6f25ef-83eb-4901-94ce-65635eac606a/artifacts/htemq9qg_Z%20%288%29.png",
    depositAmount: 30,
    note: "Depósito para confirmar tu cita. El monto se descontará del valor final del servicio.",
  },
};

export const HERO = {
  title_pre: "AURA",
  title_post: "Estética Corporal & Spa",
  subtitle: "Belleza, salud y bienestar en manos de expertas.",
  background: "https://images.unsplash.com/photo-1741522509438-a120c0bb5e88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxzcGElMjBib2R5JTIwbWFzc2FnZSUyMHJlbGF4YXRpb258ZW58MHx8fHwxNzgxNDMzNDA3fDA&ixlib=rb-4.1.0&q=85",
};

export const ABOUT = {
  title: "Sobre Nosotros",
  paragraphs: [
    "AURA nace del sueño de crear un espacio donde la estética y el bienestar se encuentran en perfecta armonía. Un refugio para reconectar contigo misma, realzar tu belleza natural y cuidar tu cuerpo de manera integral.",
    "Cada tratamiento está diseñado con técnicas profesionales, productos premium y la calidez de un equipo dedicado a tu transformación.",
  ],
  mision: "Brindar experiencias de estética y spa de la más alta calidad, fusionando técnicas avanzadas con un trato humano y personalizado, para que cada cliente recupere su confianza y bienestar.",
  vision: "Ser el centro de estética corporal y spa de referencia en Lima, reconocido por la excelencia en resultados, ética profesional y un servicio que transforma vidas.",
  director: {
    name: "Zaida Meléndez",
    role: "Directora & Especialista en Estética Corporal",
    bio: "Con años de experiencia y una pasión profunda por el bienestar femenino, Zaida lidera AURA con la convicción de que cada mujer merece sentirse hermosa, fuerte y cuidada.",
    photo: "https://images.unsplash.com/photo-1733685373178-b49c3943ccef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBhZXN0aGV0aWNpYW4lMjB3b21hbiUyMHBvcnRyYWl0fGVufDB8fHx8MTc4MTQzMzQwMnww&ixlib=rb-4.1.0&q=85",
  },
};

export const SERVICE_CATEGORIES = [
  { id: "esteticos", label: "Servicios Estéticos", short: "Estéticos" },
  { id: "especializados", label: "Tratamientos Especializados", short: "Especializados" },
];

// Precios placeholder — Zaida puede editarlos desde /admin → Servicios
export const SERVICES = [
  // SERVICIOS ESTÉTICOS
  {
    id: "s-limpieza-facial",
    category: "esteticos",
    name: "Limpieza Facial Profunda",
    description: "Extracción de impurezas, exfoliación e hidratación para una piel renovada y luminosa.",
    price: 80,
    image: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "s-acne-dermapen",
    category: "esteticos",
    name: "Tratamiento de Acné con Dermapen",
    description: "Microneedling profesional que controla el acné activo, reduce marcas y empareja la textura de la piel.",
    price: 250,
    image: "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "s-reduccion-abdomen",
    category: "esteticos",
    name: "Reducción de Abdomen con Enzimas y Drenaje",
    description: "Combinación de enzimas lipolíticas + drenaje linfático para reducir medidas y modelar la zona abdominal.",
    price: 180,
    image: "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "s-reduccion-papada",
    category: "esteticos",
    name: "Reducción de Papada",
    description: "Tratamiento focalizado para tonificar y reducir la papada, definiendo el contorno facial.",
    price: 130,
    image: "https://images.unsplash.com/photo-1612350714770-58d04030cd09?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "s-gluteos-peptonas",
    category: "esteticos",
    name: "Levantamiento de Glúteos con Peptonas o Aparatología",
    description: "Realza, tonifica y levanta tus glúteos con activos peptónicos y/o tecnología avanzada.",
    price: 220,
    image: "https://images.unsplash.com/photo-1583416750470-965b2707b355?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "s-gluteos-abdomen-ondas",
    category: "esteticos",
    name: "Levantamiento de Glúteos y Reducción de Abdomen con Ondas Rusas",
    description: "Electroestimulación con ondas rusas para esculpir glúteos y reducir abdomen sin esfuerzo.",
    price: 280,
    image: "https://images.unsplash.com/photo-1591343395082-e120087004b4?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "s-masaje-relajante",
    category: "esteticos",
    name: "Masaje Corporal Relajante",
    description: "Masaje con aceites esenciales para liberar tensiones, mejorar la circulación y restaurar el equilibrio.",
    price: 90,
    image: "https://images.unsplash.com/photo-1600334129128-685c5582fd35?crop=entropy&cs=srgb&fm=jpg&q=85",
  },

  // TRATAMIENTOS ESPECIALIZADOS
  {
    id: "t-plasma-prp",
    category: "especializados",
    name: "Plasma Rico en Plaquetas (PRP)",
    description: "Bioestimulación facial con tu propio plasma para regenerar, rejuvenecer y devolver luminosidad.",
    price: 350,
    image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "t-sueroterapia",
    category: "especializados",
    name: "Sueroterapia: Cóctel de Vida",
    description: "Infusión intravenosa de vitaminas y antioxidantes para energía, vitalidad y bienestar integral.",
    price: 250,
    image: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "t-vitamina-b12",
    category: "especializados",
    name: "Vitamina B12",
    description: "Aplicación intramuscular para combatir el cansancio, mejorar el ánimo y fortalecer el sistema nervioso.",
    price: 60,
    image: "https://images.unsplash.com/photo-1584515933487-779824d29309?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "t-hierro-iv",
    category: "especializados",
    name: "Hierro Intravenoso",
    description: "Terapia indicada para combatir la anemia, fatiga y mejorar el rendimiento físico y mental.",
    price: 180,
    image: "https://images.unsplash.com/photo-1606206522398-de8cf7f57b3a?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const PROMOTIONS = [
  {
    id: "p1",
    title: "20% OFF Primera Visita",
    description: "Conoce AURA con un descuento especial en cualquier servicio estético.",
    discount: "20%",
    image: "https://images.unsplash.com/photo-1754961968085-1f5799fd7a7c?crop=entropy&cs=srgb&fm=jpg&q=85",
    badge: "Bienvenida",
  },
  {
    id: "p2",
    title: "Paquete Corporal 360°",
    description: "5 sesiones de reducción de abdomen + 3 levantamientos de glúteos con ondas rusas.",
    discount: "Ahorro 30%",
    image: "https://images.unsplash.com/photo-1776015036303-1087ac99dc4f?crop=entropy&cs=srgb&fm=jpg&q=85",
    badge: "Más vendido",
  },
  {
    id: "p3",
    title: "Combo Vitalidad",
    description: "Sueroterapia + B12 + Hierro intravenoso. Tu cóctel de energía completa.",
    discount: "Ahorro 25%",
    image: "https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?crop=entropy&cs=srgb&fm=jpg&q=85",
    badge: "Combo",
  },
];

export const GALLERY = [
  "https://images.unsplash.com/photo-1555820585-c5ae44394b79?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1643684391140-c5056cfd3436?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1754961968085-1f5799fd7a7c?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1776015036303-1087ac99dc4f?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?crop=entropy&cs=srgb&fm=jpg&q=85",
];

export const TESTIMONIALS = [
  {
    id: "t1",
    name: "María Fernanda R.",
    text: "El mejor centro al que he ido en Lima. Zaida y su equipo son increíbles. Mi piel quedó renovada después del tratamiento de acné con Dermapen.",
    rating: 5,
    treatment: "Acné con Dermapen",
  },
  {
    id: "t2",
    name: "Camila L.",
    text: "Resultados visibles desde la primera sesión de reducción de abdomen. Súper recomendado, ambiente relajante y muy profesional.",
    rating: 5,
    treatment: "Reducción de Abdomen",
  },
  {
    id: "t3",
    name: "Daniela P.",
    text: "Después del PRP mi rostro se ve más luminoso y firme. Una experiencia que me cambió. AURA es un lugar mágico.",
    rating: 5,
    treatment: "Plasma Rico en Plaquetas",
  },
  {
    id: "t4",
    name: "Andrea V.",
    text: "La sueroterapia fue justo lo que necesitaba para recuperar mi energía. Atención impecable y manos expertas. Volveré sin duda.",
    rating: 5,
    treatment: "Sueroterapia Cóctel de Vida",
  },
];
